import produce from 'immer';
import { createSelector } from 'reselect';

import {
  SET_GRID_STATE
} from 'app/actions/types';

const initialState = {
  resource: {
    // 'jobs': {},
    // etc.
  }
}

const gridStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GRID_STATE:
      return produce(state, draft => {
        let { resource } = action.payload;
        draft.resource[resource] = action.payload;
      });
    default:
      return state;
  }
}

export default gridStateReducer;

const selectGridStateReducer = state => state.gridStateReducer;

export const selectGridState = createSelector(selectGridStateReducer, (state, resource) => {
  return state.resource[resource];
});
